import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, ActivatedRouteSnapshot, RouterEvent, ActivationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { AuthService } from '../../services/auth.service';
import { SelectedNavContextService } from './nav.context.service';

@Component({
  selector: 'app-context-menu',
  templateUrl: './nav.context.component.pug',
  styleUrls: ['./nav.context.component.sass']
})
export class NavContextComponent implements OnInit, OnDestroy {
  isAuthorizedSubscription: Subscription;
  userDataSubscription: Subscription;
  isAuthorized: boolean;

  public user: any;
  private activeContextTitle: string;
  private contextTitles: object[];

  constructor(private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private navContextService: SelectedNavContextService) {
  }

  ngOnInit() {
    this.isAuthorizedSubscription = this.authService.getIsAuthorized().subscribe(
      (isAuthorized: boolean) => {
        this.isAuthorized = isAuthorized;
      });

    this.userDataSubscription = this.authService.getUser().subscribe(
      (userData: any) => {
        this.user = userData;
      });

    this.router.events
      .filter((e): e is ActivationEnd => e instanceof ActivationEnd)
      .map((e) => (<ActivationEnd>e).snapshot)
      .map((route) => {
        while (route.firstChild) { route = route.firstChild; }
        return route;
      })
      .filter((route) => route.outlet === 'primary')
      .subscribe((route) => {
        try {
          let usedRoute = route;
          let cr = route;
          let p = route.parent;
          let contextCount = 0;
          while (p) {
            if (p.routeConfig && p.routeConfig.data && p.routeConfig.data.useNavigationContext) {
              contextCount++;
              usedRoute = cr;
            }
            cr = p;
            p = p.parent;
          }
          // tslint:disable-next-line:no-console
          if (contextCount > 1) { console.debug('Multiple navigation context is present. The upmost parents context is selected.'); }

          const contextTitleRoute = this.getContextTitleRoute(usedRoute);

          if (contextTitleRoute) {
            this.activeContextTitle = usedRoute.data.navigationContextTitle;
            this.contextTitles = this.getContextTitlesAndSetReference(contextTitleRoute);
          } else {
            this.activeContextTitle = undefined;
            this.contextTitles = undefined;
            this.navContextService.title = '';
            this.navContextService.currentReference = undefined;
            this.navContextService.clearHistory();
          }
          this.navContextService.addHistory(this.router.url);
        } catch (error) {
          console.error(error);
        }
      });
  }

  private getContextTitlesAndSetReference(activatedRoute: ActivatedRouteSnapshot): object[] {
    if (!activatedRoute || !activatedRoute.routeConfig) { return null; }

    const routeConfig = activatedRoute.routeConfig;
    if (!routeConfig.data || !routeConfig.data.useNavigationContext) {
      return this.getContextTitlesAndSetReference(activatedRoute.parent);
    }

    const children = routeConfig.children;
    if (!children) { return null; }

    const url = this.getActivatedRouteUrl(activatedRoute);
    this.navContextService.currentReference = url;

    const ctl = [];

    children.forEach(child => {
      if (child.data && child.data.navigationContextTitle) {
        const navUrl = url + (child.path ? '/' : '') + child.path;
        ctl.push({ caption: child.data.navigationContextTitle, url: navUrl, auth: child.data.auth });
      }
    });

    return ctl;
  }

  private getContextTitleRoute(activatedRoute: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    if (activatedRoute.data && activatedRoute.data.navigationContextTitle) { return activatedRoute; }
    if (activatedRoute.parent) { return this.getContextTitleRoute(activatedRoute.parent); }
    return null;
  }

  private getActivatedRouteUrl(activatedRoute: ActivatedRouteSnapshot): string {
    if (!activatedRoute || (activatedRoute.url.length === 0)) { return ''; }
    const urlSegments = activatedRoute.url;

    let url = '';
    for (let i = urlSegments.length - 1; i >= 0; i--) {
      url = '/' + urlSegments[i].path + url;
    }
    return this.getActivatedRouteUrl(activatedRoute.parent) + url;
  }

  public goBack(): void {
    if (this.navContextService.backUrl) {
      let url = this.navContextService.backUrl;
      let opts = this.navContextService.backOptions;

      this.navContextService.backUrl = undefined;
      this.navContextService.backOptions = undefined;
      if (opts) {
        this.router.navigate([url], opts);
      } else {
        this.router.navigate([url]);
      }
    }
  }

  isActiveHelper(instance, active): string {
    return instance === active ? 'active' : '';
  }

  navigate(url) {
    this.router.navigate([url]);
  }

  isContextAuthorized(contextTitle) {
    if (!contextTitle.auth) { return true; }

    return this.authService.hasAccess(contextTitle.auth.roleType, contextTitle.auth.claim);
  }

  ngOnDestroy(): void {
    this.isAuthorizedSubscription.unsubscribe();
    this.userDataSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/context-menu/nav.context.component.ts